import * as Yup from 'yup';
import Utils from 'utilities/helper.util';

// Search Enquiries validation schema
export const SearchAOEmailsSchema = Yup.object().shape({
  createdBefore: Yup.date().test(
    'dateToTest',
    'To date should be after than from date',
    function (value: any) {
      const { createdAfter } = this.parent;
      if (
        value &&
        createdAfter &&
        Utils.getNewDate(createdAfter).isAfter(value)
      )
        return false;
      return true;
    }
  )
});
